import React from "react";

import UserTable from "./User";

const AdminDashboard = () => {
  return <UserTable />;
};
export default AdminDashboard;
